import {
  CreateUpdateTextDtoTypeEnum,
  type CreateUpdateTextDto,
  type TextDto,
} from '@/api/generator';

export function toCreateUpdateTextDto(dto: TextDto): CreateUpdateTextDto {
  return {
    ...dto,
    $type:
      CreateUpdateTextDtoTypeEnum.PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoCreateUpdateTextDtoPtwPtw100AppZeroApplicationShared,
  };
}
